import React from 'react';
import { StaticListIndexSinglePageType } from '../../types';

type PaginationProps = {
  total: number;
  currentPage: number;
  pageSize: number;
  letter: string;
  pageType: StaticListIndexSinglePageType;
  languageUrlKey: string;
};

export default function Pagination({
  total,
  currentPage,
  pageSize,
  letter,
  pageType,
  languageUrlKey
}: PaginationProps) {
  /* Pagination Logic
      url page(backend page number) 1 is page 2 in pagination, no query param is page 1 in pagination
      if total page count is greater than 1 only then pagination is shown
      first and previous will be shown in all pages except for the page 1
      last and next will be shown in all pages except for the last page number
      */
  const FIRST_PAGE = 0;
  const urlPrefix = `/railways/${languageUrlKey}list-of${pageType !== 'stations' ? '-indian' : ''}${
    pageType === 'routes' ? `-train-` : `-railway-`
  }${pageType}`;

  const getPaginationUrl = (backendPageNumber) =>
    backendPageNumber === FIRST_PAGE
      ? `${urlPrefix}-by-${letter.toLowerCase()}.html` // for page 1 there is no query param in the url, for other pages add query param ?page=x in the url
      : `${urlPrefix}-by-${letter.toLowerCase()}.html?page=${backendPageNumber}`;

  const TOTAL_PAGES = Math.ceil(total / pageSize);
  const LAST_PAGE = TOTAL_PAGES - 1;
  return TOTAL_PAGES > 1 ? (
    <div className="railSeoWrap__trainIndexSinglePagination">
      {currentPage !== FIRST_PAGE ? (
        <>
          <div className="railSeoWrap__trainIndexSinglePaginationPage">
            <a href={getPaginationUrl(FIRST_PAGE)}>« first</a>
          </div>
          <div className="railSeoWrap__trainIndexSinglePaginationPage">
            <a href={getPaginationUrl(currentPage - 1)}>‹ previous</a>
          </div>
        </>
      ) : (
        ''
      )}
      {Array.from({ length: TOTAL_PAGES }, (v, k) => k)
        .filter((v) => currentPage - 2 < v && v < currentPage + 2)
        .map((idx) => {
          if (idx === currentPage) {
            return (
              <div className="railSeoWrap__trainIndexSinglePaginationPage" key={`page_${idx + 1}`}>
                {idx + 1}
              </div>
            );
          } else {
            return (
              <div className="railSeoWrap__trainIndexSinglePaginationPage" key={`page_${idx + 1}`}>
                <a href={getPaginationUrl(idx)}>{idx + 1}</a>
              </div>
            );
          }
        })}

      {currentPage !== LAST_PAGE ? (
        <>
          <div className="railSeoWrap__trainIndexSinglePaginationPage">
            <a href={getPaginationUrl(currentPage + 1)}>next ›</a>
          </div>
          <div className="railSeoWrap__trainIndexSinglePaginationPage">
            <a href={getPaginationUrl(LAST_PAGE)}>last »</a>
          </div>
        </>
      ) : (
        ''
      )}
    </div>
  ) : (
    <></>
  );
}
